import React, { Component } from 'react';
import { Menu, Container, Image, Header, Grid, Segment } from 'semantic-ui-react'

import Saisie from './Saisie'
import Hypothese from './Hypothese'
import Resultat from './Resultat'
//import {calcul} from './Utilitaire'

import './App.css';

const FRAIS_VST = 0.035
const PART_UC = 0.6
const FRAIS_GESTION = 0.01
const VALEUR_UC = 5000

const RENDEMENT_FONDS_GARANTIS = 0.02465

// @todo : se passer des css si non nécessaire
class App extends Component {
    state = {
        situation: 'favorable', // favorable / defavorable
        premier_versement: '01/06/2019', // format jj/mm/aaaa
        versement_libre: 0,
        periodicite: 'annuel', // mensuel / annuel
        prime_unique: 'non', // oui / non
        cotisation: 50000,
        rendement: 0.08,
        duree: 6
    }
    
    handleChange = (event, { name, value }) => {        
        this.setState({
            [name]: value
        })
    }
    
  render() { // @todo tous les attributs de Hypothese et Resultat sont utiles ?
    const { situation, versement_libre, periodicite, premier_versement, prime_unique, cotisation, rendement, duree } = this.state
    
    return (
      <div id="app">
        <Container style={{ marginTop: '1em' }}>
            <Menu fixed='top' inverted>
                <Container>
                  <Menu.Item as='a' header>
                    <Image size='mini' src='logo.png' style={{ marginRight: '1.5em' }} />
                    Simulateur Atlantique Platinium
                  </Menu.Item>
                  <Menu.Item className="right">
                    <i className="phone icon"></i>+225 20 31 21 41
                  </Menu.Item>
                </Container>
            </Menu>
          
            <Header as='h2' dividing style={{ marginTop: '4em', marginBottom: '1em' }}>
                <i className="cogs icon"></i>Paramètres
            </Header>
              <Saisie 
                  situation={situation}
                  premier_versement={premier_versement}
                  versement_libre={versement_libre}
                  periodicite={periodicite}
                  prime_unique={prime_unique}
                  cotisation={cotisation}
                  rendement={parseFloat(rendement)}
                  duree={parseInt(duree)}
                  handleChange={this.handleChange}
              />
             
              <Grid columns={2} style={{ marginTop: '3em', marginBottom: '3em' }}>
                  <Grid.Column>
                      <Header as='h2' dividing style={{ marginBottom: '1em' }}>
                          <i className="ellipsis horizontal icon"></i>Hypothèses
                      </Header>
                      <Hypothese
                          situation={situation}
                          premier_versement={premier_versement}
                          versement_libre={versement_libre}
                          periodicite={periodicite}
                          prime_unique={prime_unique}
                          cotisation={cotisation}
                          rendement={parseFloat(rendement)}
                          duree={parseInt(duree)}
                          frais={FRAIS_VST} />
                  </Grid.Column>
                  <Grid.Column>
                      <Header as='h2' dividing style={{ marginBottom: '1em' }}>
                        <i className="chart line icon"></i>Résultat
                      </Header>
                      <div className="ui negative message">
                        <div className="header">
                          Cette simulation n’est pas contractuelle et est établie à titre indicatif.<br/> 
                          Seul le contrat délivré par la compagnie engage les deux parties. 
                        </div>
                      </div>
                      <Resultat
                          situation={situation}
                          premierVst={premier_versement}
                          versement_libre={versement_libre}
                          periodicite={periodicite}
                          primeUnique={prime_unique}
                          cotisation={cotisation}
                          rendement={parseFloat(rendement)}
                          duree={parseInt(duree)}
                          fraisVst={FRAIS_VST}
                          partUC = {PART_UC} 
                          fraisGestion={FRAIS_GESTION}
                          valeurUC={VALEUR_UC}
                          rdtFondsGarantis={RENDEMENT_FONDS_GARANTIS} />
                      
                  </Grid.Column>
              </Grid>
          
        </Container>
        
        <Segment inverted vertical style={{ padding: '4em 0em' }}>
            <Container>
                <Grid inverted stackable>
                    <Grid.Column width={1}></Grid.Column>
                    <Grid.Column width={6}>
                      <Image size='tiny' className="middle aligned" src='logo.png' style={{ marginRight: '1.5em' }} />
                          <span>Simulateur Atlantique Platinium</span>
                    </Grid.Column>
                    <Grid.Column width={1}></Grid.Column>
                    <Grid.Column width={1}></Grid.Column>
                    <Grid.Column width={6}>
                      <p style={{textAlign: 'center'}}>
                        Pour toutes souscriptions ou questions,<br/>
                        contactez-nous au :<br/>
                        <strong style={{fontSize: '1.2em'}}>+225 20 31 21 41</strong>
                      </p>
                    </Grid.Column>
                    <Grid.Column width={1}></Grid.Column>
                </Grid>  
            </Container>
        </Segment>
        
      </div>
    );
  }
}

export default App;
